import { recuerdos } from '@/mocks/recuerdos';

type Recuerdo = (typeof recuerdos)[number];

function FotoArchivo({ item }: { item: Recuerdo }) {
  const esDocumento = item.id === 'prensa';

  return (
    <figure className="group">
      <div
        className="w-full aspect-[4/3] overflow-hidden border border-ink-900/15 bg-cream-200"
      >
        <img
          src={item.image}
          alt={item.alt}
          title={item.titleAttr}
          className={`w-full h-full transition-transform duration-[1200ms] ease-out group-hover:scale-[1.03] ${
            esDocumento ? 'object-contain' : 'object-cover object-center'
          }`}
        />
      </div>
    </figure>
  );
}

export default function Recuerdos() {
  return (
    <section id="recuerdos" className="relative bg-cream-100 py-20 md:py-28 border-t border-ink-900/10">
      <div className="max-w-[1500px] mx-auto px-6 md:px-10">
        <div className="max-w-3xl mx-auto text-center mb-12 md:mb-16">
          <div className="flex items-center justify-center gap-4 mb-6">
            <span className="h-px w-10 bg-ink-900/30"></span>
            <p className="text-[10px] md:text-[11px] tracking-widest-xl text-ink-500">
              ARCHIVO · SANO
            </p>
            <span className="h-px w-10 bg-ink-900/30"></span>
          </div>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl text-ink-900 leading-[1.08]">
            Estos son algunos de
            <br />
            nuestros recuerdos
          </h2>
          <p className="font-display italic text-xl md:text-2xl text-ink-500 mt-4">
            que perdurarán en la historia
          </p>
          <p className="text-sm md:text-base text-ink-700 leading-relaxed max-w-[52ch] mx-auto mt-7">
            Fotos de familia, de las primeras clientas, del mostrador de siempre. Cuatro
            décadas dan para muchas anécdotas, y estas son solo unas pocas de las que
            guardamos con más cariño.
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-5">
          {recuerdos.map((item) => (
            <FotoArchivo key={item.id} item={item} />
          ))}
        </div>

        <div className="mt-12 md:mt-16 pt-8 border-t border-ink-900/10 flex flex-col md:flex-row md:items-center md:justify-between gap-5">
          <p className="text-xs md:text-sm text-ink-700 max-w-[58ch] leading-relaxed">
            Si guardas alguna foto antigua de la tienda en casa, nos encantaría verla.
            Tráela la próxima vez que pases y la añadimos a nuestro archivo.
          </p>
          <a
            href="#contacto"
            className="btn-line inline-flex items-center gap-2 text-[11px] tracking-widest uppercase text-ink-900 whitespace-nowrap cursor-pointer self-start md:self-auto"
          >
            Comparte tu recuerdo
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}